import sanitize from "sanitize-html";

const ALLOWED_TAGS = [
  "html",
  "head",
  "body",
  "meta",
  "style",
  "title",
  "button",
  "article",
  "section",
  "div",
  "span",
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "a",
  "img",
  "figure",
  "figcaption",
  "blockquote",
  "cite",
  "q",
  "em",
  "strong",
  "small",
  "sup",
  "sub",
  "br",
  "hr",
  "ul",
  "ol",
  "li",
  "dl",
  "dt",
  "dd",
  "header",
  "footer",
  "nav",
  "main",
  "aside",
  "time",
  "mark",
  "abbr",
  "address",
  "picture",
  "source",
  "svg",
  "path",
  "circle",
  "rect",
  "line",
  "polyline",
  "polygon",
  "g",
  "defs",
  "use",
  "clipPath",
  "text",
];

const ALLOWED_ATTRS: Record<string, string[]> = {
  "*": ["class", "id", "lang", "dir", "role", "aria-*", "data-*", "style"],
  a: ["href", "title", "rel", "target"],
  img: ["src", "alt", "width", "height", "loading", "decoding"],
  meta: ["charset", "name", "content", "viewport"],
  source: ["srcset", "media", "type"],
  time: ["datetime"],
  abbr: ["title"],
  svg: ["viewBox", "xmlns", "fill", "stroke", "width", "height"],
  path: ["d", "fill", "stroke", "stroke-width"],
  circle: ["cx", "cy", "r", "fill", "stroke"],
  rect: ["x", "y", "width", "height", "rx", "ry", "fill"],
  line: ["x1", "y1", "x2", "y2", "stroke"],
  polyline: ["points", "fill", "stroke"],
  polygon: ["points", "fill", "stroke"],
  g: ["transform", "fill", "stroke"],
  use: ["href"],
  clipPath: ["id"],
  text: ["x", "y", "fill", "font-size"],
};

export function sanitizeHtml(html: string): string {
  return sanitize(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: ALLOWED_ATTRS,
    allowedSchemes: ["https", "http", "data"],
    allowVulnerableTags: true, // Allow <style> for embedded CSS
    allowedStyles: undefined, // Allow all inline styles
    // Keep full <style> blocks intact
    exclusiveFilter: <B extends { tag: string }>(frame: B) => {
      // Remove script-like content
      if (frame.tag === "script") return true;
      return false;
    },
  });
}
